import { createSlice } from "@reduxjs/toolkit";

type User = {
  name: string;
  photo: string;
};

type UserState = {
  currentUser: User | null;
  isAuthenticated: boolean;
  userSignInMessage: any
};

const initialState: UserState = { currentUser: null, isAuthenticated: false, userSignInMessage: ""};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.currentUser = action.payload;
      state.isAuthenticated = true;
      state.userSignInMessage = action.payload?.message || "An error occurred"
    },
    signOut: (state, action) => {
      state.currentUser = null;
      state.isAuthenticated = false;
      state.userSignInMessage = action.payload?.message || "An error occurred"
    },
  },
});

export const { signOut, signIn } = userSlice.actions;
export default userSlice.reducer;
